export default __webpack_public_path__ + "static/media/Niraj Srivastava_Intership-certificate (1) (1)_pages-to-jpg-0001.6abd0e9a.jpg";